<template>
  <v-dialog v-model="dialog" width="800" :persistent="true">
    <v-card>
      <v-card-title>
        {{recipient.email}} bearbeiten:
      </v-card-title>
      <v-card-text>
        <v-text-field v-model="FIRSTNAME" label="Vorname" />
        <v-text-field v-model="LASTNAME" label="Nachname" />

        <v-select :disabled="loading" v-model="reason" :items="['Mitglied', 'Suchmaschine', 'Anders']"
                  label="Angeworben durch" />
        <v-select :disabled="loading" v-model="referrer" v-if="reason === 'Mitglied'" :items="members" item-value="id"
                  item-text="title" label="Mitglied" />
        <v-text-field :disabled="loading" v-model="reasonText" v-if="reason === 'Anders'" label="Anders?" />
        <v-checkbox
          v-model="emailBlacklisted"
          label="Auf der Blacklist (durch Bounce o.ä.)"
        />
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" :loading="loading" @click="saveRecipient">Speichern</v-btn>
        <v-btn color="error" @click="dialog = false">Abbrechen</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex';

  export default {
    name: 'DlgEditRecipient',
    props: ['recipient', 'active'],
    data: () => ({
      reason: '',
      reasonText: '',
      referrer: '',
      FIRSTNAME: '',
      LASTNAME: '',
      emailBlacklisted: false,
      loading: false,
    }),
    watch: {
      active(val) {
        this.dialog = val;
        if (val) {
          this.emailBlacklisted = this.recipient.emailBlacklisted;
          this.FIRSTNAME = this.recipient.FIRSTNAME;
          this.LASTNAME = this.recipient.LASTNAME;

          this.referrer = this.recipient.REFERREDBYREASON;
          this.reason = this.recipient.REFERREDBY;
          if (this.reason && this.reason.indexOf('Anders (') !== -1) {
            this.reasonText = this.recipient.REFERREDBYREASON ? this.recipient.REFERREDBYREASON : this.reason.match(/\((.*)\)/)[1];
            this.reason = 'Anders';
          }
        }
      },
    },
    computed: {
      dialog: {
        get() {
          return this.active;
        },
        set(val) {
          if (!val) {
            this.$emit('close');
          }
        },
      },
      ...mapGetters({
        members: 'members/all',
      }),
    },
    methods: {
      ...mapActions({
        sSaveRecipient: 'newsletter/updateRecipient',
        readNewsletterRecipients: 'newsletter/read',
      }),
      async saveRecipient() {
        this.loading = true;

        const attributes = {
          FIRSTNAME: this.FIRSTNAME,
          LASTNAME: this.LASTNAME,
          emailBlacklisted: this.emailBlacklisted,
          REFERREDBY: this.reason,
          REFERREDBYREASON: this.reasonText,
        };

        if (this.reason === 'Mitglied') {
          attributes.REFERREDBYREASON = this.referrer;
        }

        await this.sSaveRecipient({
          id: this.recipient.id,
          attributes,
        });

        await this.readNewsletterRecipients();

        this.loading = false;
        this.dialog = false;
      },
    },
  };
</script>

<style scoped>

</style>
